<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o7Fxtw/cover.jpeg?1738887728979" alt="This image is the cover for the book Sleepers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleepers
      </h1>
      <p class="bookDescription body article font2">
        <p>As usual, the boss had slipped out early on Friday, leaving the Cellar without a leader. The atmosphere was light and relaxed – until the red phone rang. Six pairs of eyes locked onto Steven, the closest to the phone. Hesitantly, he picked up the receiver. His eyebrows arched in surprise and concern during the brief, one-sided conversation. He hung up without a word. The room held its breath. Without explanation, Steven grabbed a thick folder from his desk and, with a resigned shrug, headed towards what they called the ‘prison cell’, a stark briefing room down the tunnel to No. 10. A stray Post-it note had somehow ended up on yesterday’s briefing paper about the IRA. The damning yellow square contained Steven’s unfiltered thoughts about how civil servants needed a kick if the IRA were to be defeated. And now, she wanted a face-to-face.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Murray Campbell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2825b950